import wrapper from 'wrapper';
import 'core-js/es6/object';
import 'core-js/es6/array';
import 'core-js/es6/number';
import 'core-js/es6/promise';
import 'core-js/es7/object';
import 'core-js/es7/array';
import Map from './components/map/map';
import InputHandler from './components/input/handle-input';

/* eslint-disable no-undef */
const regionInclude = typeof newsspec26866region !== 'undefined' ? newsspec26866region : 'region_world';
new InputHandler(regionInclude);
/* eslint-enable */

wrapper.selectAll('.core-content').forEach(el => {
    el.style.display = 'none'; // eslint-disable-line no-param-reassign
});
wrapper.selectAll('.enhanced-content').forEach(el => {
    el.style.display = 'block'; // eslint-disable-line no-param-reassign
    // console.log('enhanced content loaded');
});

wrapper.markPageAsLoaded();

new Map(regionInclude);
